/* eslint-disable import/no-anonymous-default-export */
import fr from 'locales/fr'

export default {
  fr,
}
